import { Component, OnDestroy, OnInit, ViewChild, signal } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PrivacyService } from '../../services/privacy/privacy.service';
import { PrivacydialogComponent } from '../../shared/components/privacydialog/privacydialog.component';
import { AccordionModule } from 'primeng/accordion';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReceiptDetailsComponent } from './receipt-details/receipt-details.component';
import { BuyerTinComponent } from './buyer-tin/buyer-tin.component';
import { BuyerDetailsComponent } from './buyer-details/buyer-details.component';
import { DialogComponent } from '../../shared/components/dialog/dialog.component';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: false
})
export class HomeComponent implements OnInit {
  private readonly sectionVisibilityState = signal<boolean[]>([true, false, false]);
  private readonly activeIndexState = signal<string[]>(['0']);
  private readonly currentStepState = signal(1);
  private readonly sellerLegalNameState = signal<string | undefined>(undefined);
  private readonly sharedReceiptDataState = signal<any>(undefined);

  get sectionVisibility() { return this.sectionVisibilityState(); }
  set sectionVisibility(value: boolean[]) { this.sectionVisibilityState.set(value); }
  get activeIndex() { return this.activeIndexState(); }
  set activeIndex(value: string[]) { this.activeIndexState.set(value); }
  get currentStep() { return this.currentStepState(); }
  set currentStep(value: number) { this.currentStepState.set(value); }
  get sellerLegalName() { return this.sellerLegalNameState(); }
  set sellerLegalName(value: string | undefined) { this.sellerLegalNameState.set(value); }
  get sharedReceiptData() { return this.sharedReceiptDataState(); }
  set sharedReceiptData(value: any) { this.sharedReceiptDataState.set(value); }

  @ViewChild(ReceiptDetailsComponent)
  receiptDetailsComponent!: ReceiptDetailsComponent;
  @ViewChild(BuyerTinComponent)
  buyerTinComponent!: BuyerTinComponent;
  @ViewChild(BuyerDetailsComponent)
  buyerDetailsComponent!: BuyerDetailsComponent;
  receiptForm!: FormGroup;
  dialogRef: DynamicDialogRef | null = null;
  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    private privacyService: PrivacyService
  ) {}
  ngOnInit() {}

  formData: any = {
    receiptDetails: null,
    buyerTIN: null,
    buyerDetails: null,
  };

  goForward() {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }

  goBack() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  onTabClose(index: number) {
    // Logic for when a tab is closed
    console.log(`Section ${index + 1} closed`);
  }

  onTabOpen(index: number) {
    // Logic for when a tab is opened
    console.log(`Section ${index + 1} opened`);
  }

  onFormSubmit(section: any) {
    if (section.value === 1) {
      this.sellerLegalName = section.sellerLegalName;
      this.sharedReceiptData=this.receiptDetailsComponent.getFormData();
      this.formData.receiptDetails = this.receiptDetailsComponent.getFormData();
      this.activeIndex = ['1'];
      this.sectionVisibility = this.sectionVisibility.map((visible, index) =>
        index === 1 ? true : visible
      );
      this.goForward();
    } else if (section === 2) {
      this.formData.buyerTIN = this.buyerTinComponent.getFormData();
      this.activeIndex = ['2'];
      this.sectionVisibility = this.sectionVisibility.map((visible, index) =>
        index === 2 ? true : visible
      );
      this.goForward();
    } else if (section === 3) {
      this.formData.buyerDetails = this.buyerDetailsComponent.getFormData();
      console.log('send form data', this.formData);
      this.buyerDetailsComponent.confirmAndSubmit(this.formData);
    }
  }

  getHeaderText(): string {
    // Basic header text
    let headerText = 'Receipt Details';

    // Add seller name if available
    if (this.sellerLegalName) {
      headerText += ` Seller Name : ${this.sellerLegalName}`;
    }

    return headerText;
  }
  truncateText(text: string, limit: number): string {
    if (text.length > limit) {
      return text.substring(0, limit) + '...';
    }
    return text;
  }
  showConfirmationDialog() {
    this.dialogRef = this.dialogService.open(DialogComponent, {
      header: 'Confirmation',
      width: '600px',
      data: {
        title: '',
        messages: ['Resetting will clear the form. Do you wish to continue?'],
        confirm: true,
        onYes: () => this.resetForm(), // Custom action for "Yes"
        onNo: () => console.log('User canceled the reset.'), // Custom action for "No"
      },
      contentStyle: { 'max-height': '900px', overflow: 'auto' },
    });
  }
  resetForm() {
    console.log('resetting');
    if (this.currentStep >= 1) {
      this.receiptDetailsComponent.resetForm();
      this.sellerLegalName = '';
    }

    if (this.currentStep >= 2) {
      this.buyerTinComponent.resetForm();
    }

    if (this.currentStep >= 3) {
      this.buyerDetailsComponent.resetForm();
    }
    this.resetSections();
  }
  resetSections() {
    this.sectionVisibility = [true, false, false];
    this.activeIndex = ['0'];
    this.currentStep = 1;
  }
}
